module.exports = "/images/rating-google.svg?89e9d684ba5f7e0bddf3c7753393c03b";